// libraries
import React from "react";
// import { useMutation } from "@apollo/client";

// import { UpsertPreferredWorkMutationDocument } from "./__generated__/UpsertWorkPreference.generated";

// components
import { SmartHoldsSections } from "../web-settings";

import { WorkPreferenceGoal } from "@components/goals-wrapper";
import { SmartHoldSync } from "@components/smart-hold-sync";

// util
// import { logger } from "@util/logger.util";

// material-ui
import { Typography } from "@material-ui/core";

// ~-~-~-~-~-~-~-
// Focus Time Settings
// ~-~-~-~-~-~-~-
interface FocusTimeSettingsProps {
  org: any;
}

export const FocusTimeSettings = (props: FocusTimeSettingsProps) => {
  return (
    <div cw-id={`web-settings-${SmartHoldsSections.FocusTime}`}>
      <Typography variant="h2" className="cw-mb-4">
        💡 Focus Time
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Clockwise can help you create and protect uninterrupted Focus Time on your calendar. Focus
        Time is defined as two or more hours of uninterrupted time within your working hours.{" "}
        <a href={"https://getclockwise.com"} target="_blank">
          Learn more
        </a>
        .
      </Typography>
      <div className="cw-mb-16">
        <Typography variant="h3" className="cw-mb-4">
          When do you prefer to have uninterrupted time for work?
        </Typography>
        <WorkPreferenceGoal org={props.org} isWebSettings />
      </div>
      <Typography variant="h3" className="cw-mb-4">
        Schedule Focus Time on your calendar?
      </Typography>
      <Typography variant="subtitle1" className="cw-mb-6">
        Prevent others from scheduling over your Focus Time by allowing Clockwise to block it on
        your shared calendar. Focus Time events will automatically update as your schedule changes
        and can be removed if no longer needed.
      </Typography>
      <SmartHoldSync
        smartHoldType={"FocusTime"}
        renderMode={"Toggle"}
        org={props.org}
        allowAutoSave={true}
        disabled={false}
      />
    </div>
  );
};
